import { z } from 'zod';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { NewEncounterPage } from '@/features/emr/pages/NewEncounterPage';
import { readEditionFromStorage } from '@/lib/auth/storageEdition';

const searchSchema = z.object({
  patientId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/encounters/new')({
  component: NewEncounterPage,
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    if (readEditionFromStorage() === 'personal') {
      throw redirect({
        to: '/quick-start',
        search: search.patientId ? { patientId: search.patientId } : undefined,
      });
    }
    return {
      breadcrumbs: [
        { href: '/encounters', title: 'Encounters' },
        { title: 'New Encounter', href: '/encounters/new' },
      ],
    };
  },
});
